const API_BASE = '/api';
// Disable direct Dropbox access from browser - use server endpoints only
const USE_DIRECT_DROPBOX = false;

export const assetsApi = {
  async uploadAsset(file, kind = 'asset') {
    // Always use server endpoint for security
    const formData = new FormData();
    formData.append('file', file);
    formData.append('kind', kind);
    
    const response = await fetch(`${API_BASE}/upload`, { 
      method: 'POST', 
      body: formData 
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Upload failed');
    }
    
    return response.json();
  },

  async listAssets() {
    const response = await fetch(`${API_BASE}/list-assets`);
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to list assets');
    }
    return response.json();
  },

  async getAssetUrl(path) {
    const response = await fetch(`${API_BASE}/get-asset?path=${encodeURIComponent(path)}`);
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to get asset URL');
    }
    const result = await response.json();
    return result.url;
  },

  async deleteAsset(path) {
    // Server endpoint would need to be implemented for delete functionality
    console.warn('Delete functionality not implemented on server side');
    return { success: false, error: 'Delete not available' };
  },

  async healthCheck() {
    try {
      const response = await fetch(`${API_BASE}/health`);
      return response.json();
    } catch (error) {
      return { ok: false, error: error.message };
    }
  },

  async initializeStorage() {
    try {
      const response = await fetch(`${API_BASE}/initialize-storage`, { 
        method: 'POST' 
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to initialize storage');
      }
      return response.json();
    } catch (error) {
      return { success: false, error: error.message };
    }
  }
};